<template>
  <div>
    <DxPopup
      :visible="enabledPopUpSensor"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :on-hidden="onHidden"
      :show-title="false"
      :show-close-button="true"
      width="auto"
      height="auto"
    >
      <DxScrollView
        scroll-by-content
        scroll-by-thumb
        direction="both"
      >
        <div class="transparent headers-initial">
          <f7-block-title class="block-title-result">
            <span :class="`color-title-${selection}`">{{ `${$t('result.title_popUp_sensor_irrigation').toUpperCase()}` }}</span>
          </f7-block-title>
          <div class="content-text">
            <div class="first-text">
              {{ $t('result.popPupSensorIrrigation.first_text') }}
            </div>
            <div class="second-text">
              {{ $t('result.popPupSensorIrrigation.second_text') }}
            </div>
            <div class="third-text">
              {{ $t('result.popPupSensorIrrigation.third_text') }}
            </div>
            <div class="four-text">
              {{ $t('result.popPupSensorIrrigation.four_text') }}
            </div>
            <div class="five-text">
              {{ $t('result.popPupSensorIrrigation.five_text') }}
            </div>
            <div class="img-sensor" />
            <img
              class="icon-sensor-irrigation"
            >
          </div>
        </div>
        <f7-block-footer
          class="content-action-botton"
        >
          <f7-button
            class="dx-btn-success color-orange"
            raised
            type="success"
            styling-mode="contained"
            name="ButtonSave"
            @click="closePopUp"
          >
            {{ $t("button_back") }}
          </f7-button>
        </f7-block-footer>
      </DxScrollView>
    </DxPopup>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';

export default {
  name: 'FloorFormPopUp',
  components: {
    DxPopup,
    DxScrollView,
  },
  data() {
    return {
      newFloor: {},
    };
  },
  computed: {
    ...mapState('authentication', [
      'selection',
    ]),
    ...mapState('Result', ['enabledPopUpSensor']),
  },
  methods: {
    closePopUp() {
      this.onHidden();
    },
    onHidden() {
      this.setEnabledPopUpSensor(false);
    },
    ...mapActions('Result', [
      'setEnabledPopUpSensor',
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import "./popUpSensorIrrigation";
</style>
